import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { PermissionsTable } from "./permissions-table";

export const Permissions: FC = () => {
  return (
    <>
      <Typography variant="h6">Manage your Permissions</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Users can add and remove user permissions here. Super Admins have site wide access, however
        Contributors can only view, edit and manage Communications in the Program assigned to them.
        <strong>
          {
            " New users permissions may not be immediate as they will be reviewed before being granted."
          }
        </strong>
      </Typography>
      <Box sx={{ mt: 3 }}>
        <PermissionsTable />
      </Box>
    </>
  );
};
